import times from 'lodash/times';
import {CSSProperties, useEffect} from 'react';
import {requestContext} from '../../../../common/requestContext';
import {Grid} from '../../../../design-system/atoms/Grid/Grid';
import {Loading} from '../../../../design-system/atoms/Loading/Loading';
import {ThumbnailRatio} from '../../../../design-system/molecules/ThumbnailWithBadges/ThumbnailRatio.constant';
import {ThumbnailType} from '../../../../design-system/molecules/ThumbnailWithBadges/ThumbnailType.enum';
import {GroupType} from '../../../../graphql/generated/types';
import {useLazyLoadIntersection} from '../../../../lazyLoad/useLazyLoadIntersection.hook';
import {SkeletonLazyLoadProps} from '../../type';
import {Skeleton} from './Skeleton';

export function SkeletonLazyLoad({
  group,
  isLoading,
  isFetchSuccess,
  onFetch,
  children,
}: SkeletonLazyLoadProps) {
  const {type = GroupType.Unknown} = group ?? {};
  const {ref, isIntersection} = useLazyLoadIntersection();
  const {isMobile} = requestContext.requestInfo.display;

  const ratioStyle = RATIO_STYLE_MAP?.[type];
  const heightStyle = HEIGHT_STYLE_MAP?.[type];

  const isHorizontalScroll = type === GroupType.HorizontalScroll;

  useEffect(() => {
    isIntersection && onFetch();
  }, [isIntersection, onFetch]);

  if (isFetchSuccess) {
    return <>{children}</>;
  }

  if (isLoading || !isIntersection) {
    if (isHorizontalScroll && ratioStyle) {
      return (
        <div
          ref={ref}
          className="relative flex space-x-4pxr overflow-hidden px-11pxr"
        >
          {times(10, index => (
            <div key={index} className="flex-none basis-98pxr">
              <Skeleton style={ratioStyle} />
            </div>
          ))}
        </div>
      );
    }
    if (ratioStyle) {
      return (
        <Grid gapPx={4} cols={isMobile ? 3 : 6} foldableCols={6} ref={ref}>
          {times(6, index => (
            <Skeleton key={index} style={ratioStyle} />
          ))}
        </Grid>
      );
    }

    if (heightStyle) {
      return <Skeleton ref={ref} style={heightStyle} />;
    }

    // TODO: 배너 스켈레톤 처리
    return (
      <div ref={ref} className="h-[236px]! flex-center-full">
        <Loading />
      </div>
    );
  }

  return <>{children}</>;
}

const RATIO_STYLE_MAP: {[key in GroupType]?: CSSProperties} = {
  [GroupType.CardView]: {
    paddingBottom: `${100 * ThumbnailRatio[ThumbnailType.Card]}%`,
  },
  [GroupType.PosterView]: {
    paddingBottom: `${100 * ThumbnailRatio[ThumbnailType.Poster]}%`,
  },
  [GroupType.HorizontalScroll]: {
    paddingBottom: `${100 * ThumbnailRatio[ThumbnailType.Poster]}%`,
  },
  // TODO: ResponsiveBanner 어떻게 처리할지 고민해 보자.
};

const HEIGHT_STYLE_MAP: {[key in GroupType]?: CSSProperties} = {
  [GroupType.PromotionBanner]: {height: '44px'},
  [GroupType.LineBanner]: {height: '64px'},
  // TODO: DA 배너 높이 어떻게 처리할지 고민해 보자.
};
